module.exports = __webpack_public_path__ + "static/media/mysql.08e81e22.svg";